import { send } from '../../../../../../../src/network';
import { type CustomerProductRating } from '../../../../../../../src/types/CustomerProductRating';
import { type PatchedCustomerProductRating } from '../../../../../../../src/types/PatchedCustomerProductRating';

export { type PatchedCustomerProductRating };

type Params = {
  customerId: number;
  id: number;
  requestBody: PatchedCustomerProductRating;
};

export async function patchApiV2CustomersCustomerIdProductRatingsId(
  params: Params
) {
  return await send<CustomerProductRating>({
    path: `/api/v2/customers/${params.customerId}/product_ratings/${params.id}/`,
    method: 'PATCH',
    body: params.requestBody,
  });
}
